import { EoReadOnly } from '../components/Fields';
import { SectionFrame } from '../components/SectionFrame';
import type { SectionProps } from './sectionProps';

export function PayrollDetailsSection({ setup, next, back }: SectionProps) {
  const d = setup.payrollDetails;
  return (
    <SectionFrame title="Payroll Details" onSubmit={next} onBack={back}>
      <p className="eo-note">Your payroll details are set by your employer. Contact your administrator if something looks wrong.</p>
      <div className="eo-grid">
        <EoReadOnly label="Department" askKey="department" value={d.department} />
        <EoReadOnly label="Discipline / Code" askKey="discipline" value={d.discipline} />
        <EoReadOnly label="Work Type" askKey="workType" value={d.workType} />
        <EoReadOnly label="Pay Type" askKey="payType" value={d.payType} />
        <EoReadOnly label="Rate ($)" askKey="rate" value={d.rate} />
      </div>
    </SectionFrame>
  );
}
